/**
 * BillingAccountAPI
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ClientResource } from '../model/clientResource';
import { ClientResourceMapping } from '../model/clientResourceMapping';
import { CreateClientResourceDto } from '../model/createClientResourceDto';
import { ProblemDetails } from '../model/problemDetails';
import { ReadClientResourceDto } from '../model/readClientResourceDto';
import { ReadClientResourceUndeletedDto } from '../model/readClientResourceUndeletedDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class ClientResourceService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceCreateClientResourcePost(body?: CreateClientResourceDto, observe?: 'body', reportProgress?: boolean): Observable<string>;
    public apiClientResourceCreateClientResourcePost(body?: CreateClientResourceDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<string>>;
    public apiClientResourceCreateClientResourcePost(body?: CreateClientResourceDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<string>>;
    public apiClientResourceCreateClientResourcePost(body?: CreateClientResourceDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<string>('post',`${this.basePath}/api/ClientResource/CreateClientResource`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientResourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceDeleteClientResourceDelete(clientResourceId?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public apiClientResourceDeleteClientResourceDelete(clientResourceId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public apiClientResourceDeleteClientResourceDelete(clientResourceId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public apiClientResourceDeleteClientResourceDelete(clientResourceId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientResourceId !== undefined && clientResourceId !== null) {
            queryParameters = queryParameters.set('ClientResourceId', <any>clientResourceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/api/ClientResource/DeleteClientResource`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceGetAllClientResourcesGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ReadClientResourceDto>>;
    public apiClientResourceGetAllClientResourcesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReadClientResourceDto>>>;
    public apiClientResourceGetAllClientResourcesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReadClientResourceDto>>>;
    public apiClientResourceGetAllClientResourcesGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReadClientResourceDto>>('get',`${this.basePath}/api/ClientResource/GetAllClientResources`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceGetAllDeletedClientResourcesGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ReadClientResourceDto>>;
    public apiClientResourceGetAllDeletedClientResourcesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReadClientResourceDto>>>;
    public apiClientResourceGetAllDeletedClientResourcesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReadClientResourceDto>>>;
    public apiClientResourceGetAllDeletedClientResourcesGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReadClientResourceDto>>('get',`${this.basePath}/api/ClientResource/GetAllDeletedClientResources`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceGetAllMappedClientResourcesGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ReadClientResourceDto>>;
    public apiClientResourceGetAllMappedClientResourcesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReadClientResourceDto>>>;
    public apiClientResourceGetAllMappedClientResourcesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReadClientResourceDto>>>;
    public apiClientResourceGetAllMappedClientResourcesGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReadClientResourceDto>>('get',`${this.basePath}/api/ClientResource/GetAllMappedClientResources`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceGetAllNotDeletedClientResourceGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ReadClientResourceUndeletedDto>>;
    public apiClientResourceGetAllNotDeletedClientResourceGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReadClientResourceUndeletedDto>>>;
    public apiClientResourceGetAllNotDeletedClientResourceGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReadClientResourceUndeletedDto>>>;
    public apiClientResourceGetAllNotDeletedClientResourceGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReadClientResourceUndeletedDto>>('get',`${this.basePath}/api/ClientResource/GetAllNotDeletedClientResource`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceGetAllUnmappedClientResourcesGet(observe?: 'body', reportProgress?: boolean): Observable<Array<ReadClientResourceDto>>;
    public apiClientResourceGetAllUnmappedClientResourcesGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReadClientResourceDto>>>;
    public apiClientResourceGetAllUnmappedClientResourcesGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReadClientResourceDto>>>;
    public apiClientResourceGetAllUnmappedClientResourcesGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReadClientResourceDto>>('get',`${this.basePath}/api/ClientResource/GetAllUnmappedClientResources`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientId 
     * @param resourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceGetClientResourceByClientIdAndResourceIdGet(clientId?: string, resourceId?: string, observe?: 'body', reportProgress?: boolean): Observable<ReadClientResourceDto>;
    public apiClientResourceGetClientResourceByClientIdAndResourceIdGet(clientId?: string, resourceId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReadClientResourceDto>>;
    public apiClientResourceGetClientResourceByClientIdAndResourceIdGet(clientId?: string, resourceId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReadClientResourceDto>>;
    public apiClientResourceGetClientResourceByClientIdAndResourceIdGet(clientId?: string, resourceId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientId !== undefined && clientId !== null) {
            queryParameters = queryParameters.set('ClientId', <any>clientId);
        }
        if (resourceId !== undefined && resourceId !== null) {
            queryParameters = queryParameters.set('ResourceId', <any>resourceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ReadClientResourceDto>('get',`${this.basePath}/api/ClientResource/GetClientResourceByClientIdAndResourceId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientResourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceGetClientResourceByIdGet(clientResourceId?: string, observe?: 'body', reportProgress?: boolean): Observable<ReadClientResourceDto>;
    public apiClientResourceGetClientResourceByIdGet(clientResourceId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ReadClientResourceDto>>;
    public apiClientResourceGetClientResourceByIdGet(clientResourceId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ReadClientResourceDto>>;
    public apiClientResourceGetClientResourceByIdGet(clientResourceId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientResourceId !== undefined && clientResourceId !== null) {
            queryParameters = queryParameters.set('ClientResourceId', <any>clientResourceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ReadClientResourceDto>('get',`${this.basePath}/api/ClientResource/GetClientResourceById`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceGetClientResourcesByClientIdGet(clientId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ReadClientResourceDto>>;
    public apiClientResourceGetClientResourcesByClientIdGet(clientId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReadClientResourceDto>>>;
    public apiClientResourceGetClientResourcesByClientIdGet(clientId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReadClientResourceDto>>>;
    public apiClientResourceGetClientResourcesByClientIdGet(clientId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientId !== undefined && clientId !== null) {
            queryParameters = queryParameters.set('ClientId', <any>clientId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReadClientResourceDto>>('get',`${this.basePath}/api/ClientResource/GetClientResourcesByClientId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param resourceId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceGetClientResourcesByResourceIdGet(resourceId?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<ReadClientResourceDto>>;
    public apiClientResourceGetClientResourcesByResourceIdGet(resourceId?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ReadClientResourceDto>>>;
    public apiClientResourceGetClientResourcesByResourceIdGet(resourceId?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ReadClientResourceDto>>>;
    public apiClientResourceGetClientResourcesByResourceIdGet(resourceId?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (resourceId !== undefined && resourceId !== null) {
            queryParameters = queryParameters.set('ResourceId', <any>resourceId);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<ReadClientResourceDto>>('get',`${this.basePath}/api/ClientResource/GetClientResourcesByResourceId`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param clientResourceId 
     * @param mapping 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiClientResourceUnmapClientResourcePut(clientResourceId?: string, mapping?: ClientResourceMapping, observe?: 'body', reportProgress?: boolean): Observable<ClientResource>;
    public apiClientResourceUnmapClientResourcePut(clientResourceId?: string, mapping?: ClientResourceMapping, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ClientResource>>;
    public apiClientResourceUnmapClientResourcePut(clientResourceId?: string, mapping?: ClientResourceMapping, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ClientResource>>;
    public apiClientResourceUnmapClientResourcePut(clientResourceId?: string, mapping?: ClientResourceMapping, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (clientResourceId !== undefined && clientResourceId !== null) {
            queryParameters = queryParameters.set('ClientResourceId', <any>clientResourceId);
        }
        if (mapping !== undefined && mapping !== null) {
            queryParameters = queryParameters.set('mapping', <any>mapping);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<ClientResource>('put',`${this.basePath}/api/ClientResource/UnmapClientResource`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
